import { DatePivotParams } from "../../entities/date_pivot_params";

export const paramsToTransformArgs = (
  params: DatePivotParams
): Record<
  string,
  string | string[] | Date | [string, string, string[] | string][] | null
> => {
  // Keep the selected WOS measure aligned with the date hierarchy
  // (e.g. "Starting Weeks of Supply" -> "Starting Months of Supply").
  const currentMeasure = params.measure;
  const dateHierarchy = params.dateHierarchy;
  let newMeasure = currentMeasure;

  if (currentMeasure && dateHierarchy) {
    // "Weeks of Supply" / "Target Weeks of Supply" track the date hierarchy.
    const supplyMatch = currentMeasure.match(
      /^(Target\s+)?(Days|Weeks|Months) of Supply$/i
    );
    if (supplyMatch) {
      const prefix = supplyMatch[1] ? "Target " : "";
      const period =
        dateHierarchy.charAt(0).toUpperCase() + dateHierarchy.slice(1) + "s";
      const newMeasureName = `${prefix}${period} of Supply`;

      if (newMeasureName !== currentMeasure) {
        params.measure = newMeasureName;
        newMeasure = newMeasureName;
      }
    }
  }
  return {
    min_date: params.minDate ?? null,
    max_date: params.maxDate ?? null,
    date_field: params.dateHierarchy,
    measure: newMeasure || "Inventory",
    segmentation_fields: params.segments ?? [],
    filters: params.filters,
    post_filters: params.postFilters ?? [],
    value_field: params.measure ?? "",
  };
};
